import type { Bonus } from "@/domains/job-offer/types";

// New Project Type enum
export const PROJECT_TYPE = [
  "Start-up",
  "Progetto in Corsa",
  "Consulenza",
] as ProjectType[];

export enum ProjectType {
  STARTUP = "Start-up",
  PROGETTO_IN_CORSA = "Progetto in Corsa",
  CONSULENZA = "Consulenza",
}

export enum Effort {
  UNDER_20 = "20-",
  TWENTY_TO_THIRTY = "20-30",
  THIRTY_PLUS = "30+",
  FORTY = "40",
}

export const EFFORT = ["20-", "20-30", "30+", "40"] as Effort[];

export enum PaymentType {
  FIXED = "fixed",
  DAILY = "daily",
}

export const PAYMENT_TYPE = [
  PaymentType.FIXED,
  PaymentType.DAILY,
] as PaymentType[];

// New Duration enum
export const DURATION = [
  "1_month",
  "1_3_months",
  "3_6_months",
  "6_12_months",
  "12_plus_months",
] as Duration[];

export enum Duration {
  ONE_MONTH = "1_month",
  ONE_TO_THREE_MONTHS = "1_3_months",
  THREE_TO_SIX_MONTHS = "3_6_months",
  SIX_TO_TWELVE_MONTHS = "6_12_months",
  TWELVE_PLUS_MONTHS = "12_plus_months",
}

export enum ExperienceLevel {
  ZERO_TO_ONE = "0-1",
  ONE_TO_THREE = "1-3",
  THREE_TO_SEVEN = "3-7",
  SEVEN_PLUS = "7+",
}

export const EXPERIENCE_LEVEL: ExperienceLevel[] = [
  ExperienceLevel.ZERO_TO_ONE,
  ExperienceLevel.ONE_TO_THREE,
  ExperienceLevel.THREE_TO_SEVEN,
  ExperienceLevel.SEVEN_PLUS,
];

export const BONUS_ENUM = [
  "roi",
  "provision",
  "work_for_equity",
  "other",
] as Bonus[];

export enum BonusEnum {
  ROI = "roi",
  PROVISION = "provision",
  WORK_FOR_EQUITY = "work_for_equity",
  OTHER = "other",
}

// The 8 categories of `GET /v1/taxonomy`, in the order of the endpoint.
export const jobCategoryEnum = [
  "Web Mobile & Software Dev",
  "Design & Creative",
  "Sales & Marketing",
  "Writing",
  "Accounting & Consulting",
  "Data Science & Analytics",
  "Engineering & Architecture",
  "Customer Service",
] as JobCategoryEnum[];

export enum JobCategoryEnum {
  WEB_MOBILE_SOFTWARE_DEV = "Web Mobile & Software Dev",
  DESIGN_CREATIVE = "Design & Creative",
  SALES_MARKETING = "Sales & Marketing",
  WRITING = "Writing",
  ACCOUNTING_CONSULTING = "Accounting & Consulting",
  DATA_SCIENCE_ANALYTICS = "Data Science & Analytics",
  ENGINEERING_ARCHITECTURE = "Engineering & Architecture",
  CUSTOMER_SERVICE = "Customer Service",
}

export type JobCategory = (typeof jobCategoryEnum)[number];

/** The only membership check of the 8 categories: an exact English key. */
export const isJobCategory = (value: unknown): value is JobCategory =>
  typeof value === "string" && jobCategoryEnum.some((key) => key === value);

export enum StartDate {
  URGENT = "urgent",
  TWO_TO_FOUR_WEEKS = "2_4_weeks",
  FOUR_TO_EIGHT_WEEKS = "4_8_weeks",
  EIGHT_TO_TWELVE_WEEKS = "8_12_weeks",
  TWELVE_PLUS_WEEKS = "12_plus_weeks",
}

export const START_DATE = [
  "urgent",
  "2_4_weeks",
  "4_8_weeks",
  "8_12_weeks",
  "12_plus_weeks",
] as StartDate[];

export const REMOTE_POLICY = ["remote", "onsite", "hybrid"] as RemotePolicy[];

export enum RemotePolicy {
  REMOTE = "remote",
  ONSITE = "onsite",
  HYBRID = "hybrid",
}
